module.exports = __webpack_public_path__ + "img/8a1566e.png";